import axios from "../config/axios";
import config from "../config";
import util from "../util";
const billing = {
    addCreditCard: ( data ) =>
        axios
        .post(`/billing/Billing/addCreditCard`,data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err)),
    delCreditCard: (data) =>
        axios
        .post(`/billing/Billing/delCreditCard`, data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err)),
    makePrimeCard: (data) =>
        axios
        .post(`/billing/Billing/primeCreditCard`, data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err)),
    calcelSubscription: (data) =>
        axios
        .post(`/billing/Billing/cancel_user_subscription`, data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err)),
    plgCancelSubscription: (data) =>
        axios
        .post(`/billing/Billing/plg_cancel_subscription`, data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err)),
    plgCancelInfo: (data) =>
        axios
        .post(`/billing/Billing/plg_cancel_info`, data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err)),
    reactivateSubscription: (data) =>
        axios
        .post(`/billing/Billing/reactivateSubscription`, data)
        .then((resp) => resp.data)
        .catch((err) => {
            console.error('Error reactivating subscription:', err);
            return Promise.reject(err);
        }),
    GetUserBillingInfo: (data) =>
        axios
        .post(`/billing/Billing/getUserBillingInfo`,data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err)),
    GetAllInvoices: (data) =>
        axios
            .post(`/billing/Billing/getMonthlyInvoiceReport`,data)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    GetInvoiceDetail: (data) =>
        axios
            .post(`/billing/Billing/getInvoiceFullDetail`,data)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    GetInvoices: ( data ) => 
        axios
        .post(`/billing/Billing/get_Invoices`,data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err)),
    GetMonthlyRengaged : ( data ) => 
        axios
        .post(`/billing/Billing/getMonthlyExpenseReport`,data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err)),
    GetMonthlyvoiceUsage : ( data ) => 
            axios
            .post(`/billing/Billing/getMonthlyvoiceUsage`,data)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    ExportBillingCsv : ( data ) => 
        axios
        .post(`/billing/Billing/exportBillingCsv`,data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err)),
    GetUserCards : ( data ) => 
        axios
        .post(`/billing/Billing/getUserCards`,data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err)),    
    GetUserBillingDetail : ( data ) => 
        axios
        .post(`/billing/Billing/user_billing_overview`,data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err)),
    getAlertsBudget: () =>
        axios
        .post(`${config.apiBaseURL2}billing-alerts-budget`, {})
        .then((resp) => resp.data),
    saveAlertsBudget: (data) =>
        axios
        .post(`${config.apiBaseURL2}billing-alerts-budget/save`, data)
        .then((resp) => resp.data),
    GetUserLinktoken : ( data ) => 
        axios
        .post(`/billing/Billing/generateUserLink`,data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err)), 
    
        fetchzoholink : ( data ) => 
            axios
            .post(`/billing/Billing/fetchzoholink`,data)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)), 
            
        getZohoUserCards : ( data ) => 
            axios
            .post(`/billing/Billing/getZohoUserCards`,data)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
            
        getBillingEmails : ( data ) => {
            // Use apiBaseURL2 for newengage/public/api endpoint
            return axios
                .post(`${config.apiBaseURL2}customer-billing-email`, data)
                .then((resp) => resp.data)
                .catch((err) => console.log(err));
        },
        
        addBillingEmail : ( data ) => {
            // Use apiBaseURL2 for newengage/public/api endpoint
            return axios
                .post(`${config.apiBaseURL2}customer-billing-email/create`, data)
                .then((resp) => resp?.data)
                .catch((err) => {
                    // Ensure the error object is properly rejected with all response data
                    return Promise.reject(err);
                });
        },
        
        updateBillingEmail : ( data ) => {
            return axios
                .post(`${config.apiBaseURL2}customer-billing-email/update`, data)
                .then((resp) => resp?.data)
                .catch((err) => {
                    // Ensure the error object is properly rejected with all response data
                    return Promise.reject(err);
                });
        },
        
        deleteBillingEmail : ( data ) => {
            // Use apiBaseURL2 for newengage/public/api endpoint
            return axios
                .post(`${config.apiBaseURL2}customer-billing-email/delete`, data)
                .then((resp) => resp.data)
                .catch((err) => console.log(err));
        },

    // Fetch PLG plans from Zoho (filtered by plan_code starting with "PLG_")
    GetPlgPlans: (data) =>
        axios
            .post(`/billing/Billing/getPlgPlans`, data)
            .then((resp) => resp.data)
            .catch((err) => {
                console.error('Error fetching PLG plans:', err);
                return { status: false, plans: [], error: err };
            }),

    // Change PLG plan (create or update subscription)
    ChangePlgPlan: (data) =>
        axios
            .post(`/billing/Billing/changePlgPlan`, data)
            .then((resp) => resp.data)
            .catch((err) => {
                console.error('Error changing PLG plan:', err);
                return Promise.reject(err);
            }),

    // Get available voice add-ons for PLG accounts
    GetVoiceAddons: (data) =>
        axios
            .post(`/billing/Billing/getVoiceAddons`, data)
            .then((resp) => resp.data)
            .catch((err) => {
                console.error('Error fetching voice add-ons:', err);
                return { status: false, addons: [], error: err };
            }),

    // Update automatic call reloads preference
    UpdateAutoReloadPreference: (data) =>
        axios
            .post(`/billing/Billing/updateAutoReloadPreference`, data)
            .then((resp) => resp.data)
            .catch((err) => {
                console.error('Error updating auto-reload preference:', err);
                return { status: false, error: err };
            }),

    // Get PLG usage and calls (with 80% warning)
    GetPlgUsage: (data) =>
        axios
            .post(`/billing/Billing/getPlgUsage`, data)
            .then((resp) => resp.data)
            .catch((err) => {
                console.error('Error fetching PLG usage:', err);
                return { status: false, error: err };
            }),

    // Calculate prorated charge for plan change preview
    CalculatePlanChangeCharge: (data) =>
        axios
            .post(`/billing/Billing/calculatePlanChangeCharge`, data)
            .then((resp) => resp.data)
            .catch((err) => {
                console.error('Error calculating plan change charge:', err);
                return { status: false, error: err };
            }),

}

export default billing;